<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.customers'), $t('text.list')]">
        <template v-if="Permit.canActions('customerManage')">
          <el-button type="success" size="mini" @click="create()"
            >+ {{ $t("text.create") }}</el-button
          >
          <el-button
            v-if="Permit.canActions('customerManage')"
            type="default"
            size="mini"
            @click="$router.push('/normal/customers/import')"
            >{{ $t("action.import") }}</el-button
          >
        </template>
      </breadcrumb>
    </div>
    <div class="search main-border-top">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.namePhone')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="searchForm.ownerId"
            filterable
            clearable
            :placeholder="$t('text.owner')"
            size="small"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="62"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column field="name" :title="$t('text.name')" min-width="100">
          <template v-slot="{ row }">
            <span class="a" @click="showRow(row)">{{ row.name }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="phone"
          :title="$t('customer.phone')"
          min-width="110"
        >
          <template v-slot="{ row }">
            {{ row.phone }}
            <div class="font10" v-if="row.email != null">
              {{ $t("customer.email") }}: {{ row.email }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="source"
          :title="$t('customer.source')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.source }}
            <div v-if="row.sourceRemark != null" class="font10">
              {{ $t("text.explain") }}:
              <raw-html-limit-number :content="row.sourceRemark" :number="16" />
            </div>
            <div v-if="row.suggestId != null" class="font10">
              {{ $t("customer.suggestName") }}:{{ row.suggestName }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="address"
          :title="$t('tenant.address')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.province }} {{ row.city }}
            <div class="font10">
              {{ row.address }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="16" />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="weddingDay"
          :title="$t('customer.weddingDay')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.weddingDay }}
            <span
              v-if="row.weddingDay != null"
              class="font10 a"
              @click="
                Permit.isFreeEdition()
                  ? checkTenantValid('weddingDay', row)
                  : weddingDay(row)
              "
            >
              {{ $t("action.synWeddingDay") }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        />
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column field="lastFollow" :title="'最新跟踪'" min-width="80">
          <template v-slot="{ row }">
            <raw-html-limit-number
              v-if="row.lastFollow != null"
              :content="JSON.parse(row.lastFollow).content"
              :number="16"
            />
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="120"
          v-if="
            Permit.canActions('customerManage') ||
            Permit.canActions('customerDelete')
          "
          fixed="right"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button
              v-if="Permit.canActions('customerManage')"
              type="text"
              size="mini"
              @click="edit(row, rowIndex)"
              >{{ $t("text.edit") }}</el-button
            >
            <el-popconfirm
              v-if="Permit.canActions('customerDelete')"
              :title="$t('prompt.confirmDelete')"
              @confirm="deleteRow(row)"
              class="mgl10 mgr10"
            >
              <el-button slot="reference" type="text" size="mini">
                {{ $t("text.delete") }}
              </el-button>
            </el-popconfirm>
            <el-button
              v-if="Permit.canActions('customerManage')"
              type="text"
              size="mini"
              @click="addServiceFollow(row)"
              >{{ $t("customer.follows") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 编辑客户 -->
    <el-dialog
      :title="$t('rules.edit', [$t('menu.customers')])"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="60%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="80px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('user.name')"
                :prop="'name'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('user.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customer.email')" :prop="'email'">
                <el-input
                  size="small"
                  v-model.trim="editObj.email"
                  :placeholder="$t('customer.email')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('customer.weddingDay')"
                :prop="'weddingDay'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('customer.weddingDay')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  size="small"
                  v-model="editObj.weddingDay"
                  type="date"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.province')" :prop="'province'">
                <el-input size="small" v-model.trim="editObj.province" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.city')" :prop="'city'">
                <el-input size="small" v-model.trim="editObj.city" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.address')" :prop="'address'">
                <el-input size="small" v-model.trim="editObj.address" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('customer.source')">
                <el-select
                  size="small"
                  v-model="editObj.source"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="source in sources"
                    :key="source.id"
                    :label="source.name"
                    :value="source.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customer.sourceRemark')">
                <el-autocomplete
                  size="small"
                  v-model="editObj.sourceRemark"
                  :fetch-suggestions="querySearchSourceRemarks"
                  style="width: 100%"
                  @select="handleSelectSourceRemarks"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('customer.suggestName')"
                :prop="'suggestName'"
              >
                <el-select
                  size="small"
                  v-model.trim="editObj.suggestId"
                  filterable
                  remote
                  clearable
                  :loading="customersLoading"
                  :placeholder="$t('customer.phoneName')"
                  :remote-method="querySearchCustomerSuggest"
                  @change="handleSelectCustomerSuggest"
                >
                  <el-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :label="customer.name + '(' + customer.phone + ')'"
                    :value="customer.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.remark") }}</legend>
          <el-input
            size="small"
            v-model.trim="editObj.remark"
            type="textarea"
            :rows="3"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增客户 -->
    <el-dialog
      :title="$t('rules.create', [$t('menu.customers')])"
      :close-on-click-modal="false"
      :visible.sync="addDF"
      width="60%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="80px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('user.phone')"
                :prop="'phone'"
                :rules="[
                  { required: true, validator: validatePhone, trigger: 'blur' },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('user.name')"
                :prop="'name'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('user.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customer.email')" :prop="'email'">
                <el-input
                  size="small"
                  v-model.trim="editObj.email"
                  :placeholder="$t('customer.email')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.province')" :prop="'province'">
                <el-input size="small" v-model.trim="addObj.province" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.city')" :prop="'city'">
                <el-input size="small" v-model.trim="addObj.city" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.address')" :prop="'address'">
                <el-input size="small" v-model.trim="addObj.address" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item :label="$t('customer.source')">
                <el-select
                  size="small"
                  v-model="addObj.source"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="source in sources"
                    :key="source.id"
                    :label="source.name"
                    :value="source.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customer.sourceRemark')">
                <el-autocomplete
                  size="small"
                  v-model="addObj.sourceRemark"
                  :fetch-suggestions="querySearchSourceRemarks"
                  style="width: 100%"
                  @select="handleSelectSourceRemarks"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('customer.suggestName')"
                :prop="'suggestName'"
              >
                <el-select
                  size="mini"
                  v-model.trim="addObj.suggestId"
                  filterable
                  remote
                  clearable
                  :loading="customersLoading"
                  :placeholder="$t('customer.phoneName')"
                  :remote-method="querySearchCustomerSuggest"
                  @change="handleSelectCustomerSuggest"
                >
                  <el-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :label="customer.name + '(' + customer.phone + ')'"
                    :value="customer.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('customer.weddingDay')"
                :prop="'weddingDay'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('customer.weddingDay')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  size="small"
                  v-model="addObj.weddingDay"
                  type="date"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.remark") }}</legend>
          <el-input
            size="small"
            v-model.trim="addObj.remark"
            type="textarea"
            :rows="3"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>
    <!-- 跟踪 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('customer.follow')"
      :close-on-click-modal="false"
      :visible.sync="addFollowDF"
      width="30%"
    >
      <el-form ref="addFollowForm" label-width="70px" :model="addFollowObj">
        <el-form-item
          :label="$t('text.content')"
          :prop="'content'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('text.content')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addFollowObj.content"
            :placeholder="$t('text.content')"
            type="textarea"
          />
        </el-form-item>
        <el-form-item :prop="'content'">
          <el-checkbox
            v-model="addFollowObj._scheduleDF"
            @change="setScheduleDF"
            >有预约</el-checkbox
          >
        </el-form-item>
        <template v-if="addFollowObj._scheduleDF == true">
          <el-form-item
            :label="$t('schedule.title')"
            :prop="'_title'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('schedule.title')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input size="small" v-model.trim="addFollowObj._title" />
          </el-form-item>
          <el-form-item
            :label="$t('schedule.type')"
            :prop="'_type'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('schedule.type')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              size="small"
              v-model.trim="addFollowObj._type"
              filterable
              clearable
            >
              <el-option
                v-for="scheduleType in scheduleTypes"
                :key="scheduleType.id"
                :label="scheduleType.name"
                :value="scheduleType.name"
              />
            </el-select>
          </el-form-item>

          <el-row>
            <el-col :span="16">
              <el-form-item
                :label="$t('text.date')"
                :prop="'_planAt1'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.date')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-date-picker
                  id="right-radius"
                  size="small"
                  v-model.trim="addFollowObj._planAt1"
                  type="date"
                  style="width: 100%"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label-width="0px"
                :prop="'_planAt2'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.time')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-time-select
                  size="small"
                  id="left-radius"
                  style="width: 100%"
                  v-model="addFollowObj._planAt2"
                  :picker-options="{
                    start: '08:30',
                    step: '00:30',
                    end: '20:30',
                  }"
                >
                </el-time-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            :label="$t('menu.shops')"
            :prop="'_shopId'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('menu.shops')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-select
              size="small"
              v-model="addFollowObj._shopId"
              filterable
              clearable
            >
              <el-option
                v-for="shop in shops"
                :key="shop.id"
                :label="shop.name"
                :value="shop.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('customer.source')">
            <el-select
              size="small"
              v-model="addFollowObj._source"
              clearable
              filterable
            >
              <el-option
                v-for="source in sources"
                :key="source.id"
                :label="source.name"
                :value="source.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('customer.sourceRemark')">
            <el-autocomplete
              size="small"
              v-model="addFollowObj._sourceRemark"
              :fetch-suggestions="querySearchSourceRemarks"
              style="width: 100%"
              @select="handleSelectSourceRemarks"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item
            :label="$t('customer.suggestName')"
            :prop="'suggestName'"
          >
            <el-select
              size="small"
              v-model.trim="addFollowObj._suggestId"
              filterable
              remote
              clearable
              :loading="customersLoading"
              :placeholder="$t('customer.phoneName')"
              :remote-method="querySearchCustomerSuggest"
              @change="handleSelectCustomerSuggest"
            >
              <el-option
                v-for="customer in customers"
                :key="customer.id"
                :label="customer.name + '(' + customer.phone + ')'"
                :value="customer.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.remark')" :prop="'_content'">
            <el-input
              size="small"
              v-model.trim="addFollowObj._content"
              type="textarea"
            />
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addFollowDoing"
          size="small"
          @click="addServiceFollowSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addFollowDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 纪念日提醒 -->
    <el-dialog
      :title="$t('text.create')"
      :close-on-click-modal="false"
      :visible.sync="weddingDayDF"
      width="50%"
    >
      <el-form
        ref="weddingDayObjForm"
        :model="weddingDayObj"
        label-width="70px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('schedule.title')"
              :prop="'title'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('schedule.title')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-autocomplete
                size="small"
                v-model.trim="weddingDayObj.title"
                :fetch-suggestions="querySearchTitle"
                style="width: 100%"
                @select="handleSelectTitle"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.time')"
              :prop="'_planAt2'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.time')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-time-select
                size="small"
                style="width: 100%"
                v-model="weddingDayObj._planAt2"
                :picker-options="{
                  start: '08:30',
                  step: '00:30',
                  end: '20:30',
                }"
              >
              </el-time-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('customer.source')">
              <el-select
                size="small"
                v-model="weddingDayObj.source"
                clearable
                filterable
              >
                <el-option
                  v-for="source in sources"
                  :key="source.id"
                  :label="source.name"
                  :value="source.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('customer.sourceRemark')">
              <el-autocomplete
                size="small"
                v-model="weddingDayObj.sourceRemark"
                :fetch-suggestions="querySearchSourceRemarks"
                style="width: 100%"
                @select="handleSelectSourceRemarks"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('menu.shops')"
              :prop="'shopId'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('menu.shops')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model.trim="weddingDayObj.shopId"
                filterable
              >
                <el-option
                  v-for="shop in shops"
                  :key="shop.id"
                  :label="shop.name"
                  :value="shop.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('customer.suggestName')"
              :prop="'suggestName'"
            >
              <el-select
                size="small"
                v-model.trim="weddingDayObj.suggestId"
                filterable
                remote
                clearable
                :loading="customersLoading"
                :placeholder="$t('customer.phoneName')"
                :remote-method="querySearchCustomerSuggest"
                @change="handleSelectCustomerSuggest"
              >
                <el-option
                  v-for="customer in customers"
                  :key="customer.id"
                  :label="customer.name + '(' + customer.phone + ')'"
                  :value="customer.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="$t('text.remark')" :prop="'content'">
          <el-input size="small" v-model.trim="weddingDayObj.content" />
        </el-form-item>
        <el-form-item :label="$t('schedule.year')">
          <el-tag
            v-for="(weddingYear, weddingYearIndex) of weddingYears"
            :key="weddingYearIndex"
            :effect="weddingYear.selectDF == true ? 'dark' : 'plain'"
            size="mini"
            @click="selectWeddingYear(weddingYearIndex)"
            :style="
              weddingYearIndex == 0
                ? 'margin-top: 9px;margin-left: 0px'
                : 'margin-top: 9px'
            "
          >
            {{ weddingYear.name }}
          </el-tag>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="weddingDaySubmitDoing"
          size="small"
          @click="weddingDaySubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="weddingDayDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Show from "./show";
import User from "@/api/user.js";
import Customer from "@/api/customer.js";
import Shop from "@/api/shop.js";
import ScheduleType from "@/api/scheduleType.js";
import Schedule from "@/api/schedule.js";
import Source from "@/api/source.js";
import UserAuth from "@/api/userAuth.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Show,
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(new Error(self.$t("rules.required", [self.$t("user.phone")])));
        return;
      }
      Customer.findByPhone({ keyword: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(new Error(self.$t("prompt.hasBeenAdded")));
          return;
        } else {
          User.findByPhone({ phone: value }).then(function (res) {
            if (res.data.code === 200) {
              const user = res.data.entity;
              if (user.tenantId === self.Permit.currentTenant().id) {
                callback(new Error(self.$t("prompt.notAddOneself")));
                return;
              }
              if (user.admin === false) {
                callback(new Error(self.$t("prompt.notAddSubaccounts")));
                return;
              }
              self.addObj.name = user.tenant.placeName;
              self.addObj.province = user.tenant.province;
              self.addObj.city = user.tenant.city;
              self.addObj.address = user.tenant.address;
              self.addObj.sourceTenantId = user.tenant.id;
              callback();
            } else {
              self.addObj.sourceTenantId = null;
              callback();
              return;
            }
          });
        }
      });
    };
    return {
      searchForm: {
        keyword: null,
        ownerId: null,
      },
      sorter: {
        sortBy: "customer_id",
        sortIndicator: "desc",
      },
      users: [],
      // 编辑
      sources: [],
      row: null,
      rowIndex: null,
      editDF: false,
      editObj: {
        phone: null,
        name: null,
        province: null,
        city: null,
        address: null,
        source: null,
        sourceRemark: null,
        remark: null,
        email: null,
        suggestId: null,
        weddingDay: null,
      },
      editDoing: false,
      // 新增
      validatePhone: validatePhone,
      addDF: false,
      customersLoading: false,
      customers: [],
      addObj: {
        name: null,
        phone: null,
        email: null,
        province: null,
        city: null,
        address: null,
        source: null,
        sourceRemark: null,
        remark: null,
        suggestId: null,
        weddingDay: null,
      },
      addDoing: false,
      //
      currentRowId: null,
      showDF: false,
      // 跟踪
      addFollowDF: false,
      addFollowObj: {
        content: null,
        _scheduleDF: false,
        _title: null,
        _type: null,
        _planAt: null,
        _planAt1: null,
        _planAt2: null,
        _shopId: null,
        _content: null,
        _source: null,
        _sourceRemark: null,
        _suggestId: null,
      },
      scheduleTypes: [],
      shops: [],
      addFollowDoing: false,
      //
      row: null,
      // 新增结婚纪念日提醒
      weddingDayDF: false,
      weddingDayObj: {
        title: null,
        _planAt1: null,
        _planAt2: null,
        planAt: null,
        customerId: null,
        customerName: null,
        content: null,
        shopId: null,
        years: [],
        source: null,
        sourceRemark: null,
        suggestId: null,
      },
      weddingYears: [],
      weddingDaySubmitDoing: false,
    };
  },
  computed: {
    implicit() {
      return {
        deleteAt: "no",
      };
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    axios.all([User.findByTenantId(self.Permit.currentTenant().id)]).then(
      axios.spread(function (users) {
        if (users.status === 200) {
          self.users = users.data.filter((u) => u.authorizeW === true);
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },

    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (
          self.selectRecords.length === 0 ||
          self.selectRecords.length > 100000
        ) {
          self.$message.error(self.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: 100000,
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (self.pager.total === 0 || self.pager.total > 100000) {
          self.$message.error(this.$t("prompt.downloadDataRange100000"));
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = 100000;
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Customer.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    checkTenantValid(action, row) {
      const self = this;
      self.row = row;
      UserAuth.checkTenantValid().then(function (res) {
        if (res.status == 200) {
          if (res.data.type == "fail") {
            self.sysResultCheckTenantValid(res.data);
            return;
          }
          if (action == "weddingDay") {
            self.weddingDay(row);
          }
        } else {
          self.sysError();
        }
      });
    },
    // 结婚纪念日提醒

    weddingDay(row) {
      const self = this;
      self.weddingDayObj.title = "结婚纪念日";
      self.weddingDayObj.planAt = null;
      self.weddingDayObj._planAt1 = row.weddingDay;
      self.weddingDayObj._planAt2 = null;
      self.weddingDayObj.customerId = row.id;
      self.weddingDayObj.customerName = row.name;
      self.weddingDayObj.content = null;
      self.weddingDayObj.shopId = null;
      self.weddingDayObj.source = row.source;
      self.weddingDayObj.sourceRemark = row.sourceRemark;
      self.weddingDayObj.suggestId = row.suggestId;
      self.weddingDayObj.years = [];
      let currentYear = new Date().getFullYear();
      self.weddingYears = [
        { name: currentYear, selectDF: true },
        { name: currentYear + 1, selectDF: false },
        { name: currentYear + 2, selectDF: false },
        { name: currentYear + 3, selectDF: false },
        { name: currentYear + 4, selectDF: false },
        { name: currentYear + 5, selectDF: false },
      ];
      self.getSources();
      Shop.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.shops = res.data;
          if (
            self.shops.find((s) => s.id == self.Permit.currentUser()._shopId) !=
            null
          ) {
            self.weddingDayObj.shopId = self.Permit.currentUser()._shopId;
          }
        } else {
          self.sysError();
        }
      });
      self.weddingDaySubmitDoing = false;
      self.weddingDayDF = true;
    },
    selectWeddingYear(weddingYearIndex) {
      this.weddingYears[weddingYearIndex].selectDF =
        !this.weddingYears[weddingYearIndex].selectDF;
    },
    querySearchTitle(queryString, cb) {
      const self = this;
      Schedule.vagueFindTitle({ title: queryString }).then(function (res) {
        const ps = [...new Set(res.data)].map((r) => {
          return { value: r };
        });
        self.titles = ps;
        cb(self.titles);
      });
    },
    handleSelectTitle() {},
    weddingDaySubmit() {
      const self = this;
      self.$refs.weddingDayObjForm.validate((valid) => {
        if (valid) {
          const years = self.weddingYears.filter((w) => w.selectDF == true);
          if (years.length == 0) {
            self.$message({
              message: "至少选择一个年份",
              type: "warning",
            });
            return;
          }
          self.weddingDayObj.years = years.map((y) => y.name);
          this.weddingDayObj.planAt =
            Util.formatDate(this.weddingDayObj._planAt1) +
            " " +
            this.weddingDayObj._planAt2 +
            ":00";
          self.weddingDaySubmitDoing = true;
          Schedule.addSpecialDay(self.weddingDayObj).then(function (res) {
            self.weddingDaySubmitDoing = false;
            self.weddingDayDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 新增
    create() {
      const self = this;
      this.addObj.phone = null;
      this.addObj.name = null;
      this.addObj.email = null;
      this.addObj.province = null;
      this.addObj.city = null;
      this.addObj.address = null;
      this.addObj.source = null;
      this.addObj.sourceRemark = null;
      this.addObj.remark = null;
      this.addObj.suggestId = null;
      this.addObj.weddingDay = null;
      this.saveDoing = false;
      this.getSources();
      this.addDF = true;
      if (self.Permit.currentUser()._shopId != null) {
        Shop.findByTenantId().then(function (res) {
          if (res.status == 200) {
            const obj = res.data.find(
              (s) => s.id == self.Permit.currentUser()._shopId
            );
            if (obj != null) {
              self.addObj.province = obj.province;
              self.addObj.city = obj.city;
              self.addObj.address = obj.address;
            }
          } else {
            self.sysError();
          }
        });
      }
    },
    getSources() {
      const self = this;
      Source.findByTenantId().then(function (res) {
        if (res.status == 200) {
          self.sources = res.data;
        } else {
          self.sysError();
        }
      });
    },
    querySearchCustomerSuggest(queryString, cb) {
      const self = this;
      self.addObj.suggestId = null;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.customersLoading = true;
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        self.customers = res.data;
        self.customersLoading = false;
      });
    },
    handleSelectCustomerSuggest() {
      const self = this;
    },
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          if (this.addObj.settleType) {
            this.addObj.settleType = "now";
          } else {
            this.addObj.settleType = null;
          }
          self.addObj.weddingDay =
            self.addObj.weddingDay != null
              ? Util.formatDate(self.addObj.weddingDay)
              : null;
          self.addDoing = true;
          Customer.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      Customer.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    edit(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.editObj.name = row.name;
      this.editObj.phone = row.phone;
      this.editObj.email = row.email;
      this.editObj.province = row.province;
      this.editObj.city = row.city;
      this.editObj.address = row.address;
      this.editObj.source = row.source;
      this.editObj.sourceRemark = row.sourceRemark;
      this.editObj.remark = row.remark;
      this.editObj.suggestId = row.suggestId;
      this.editObj.weddingDay = row.weddingDay;
      this.editDoing = false;
      this.editDoing = false;
      this.getSources();
      this.editDF = true;
    },
    // 具体来源
    querySearchSourceRemarks(queryString, cb) {
      Customer.sourceRemarks().then(function (res) {
        const sourceRemarks = res.data.map((item) => {
          return { value: item };
        });
        cb(sourceRemarks);
      });
    },
    handleSelectSourceRemarks(item) {},
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editObj.weddingDay =
            self.editObj.weddingDay != null
              ? Util.formatDate(self.editObj.weddingDay)
              : null;
          self.editDoing = true;
          Customer.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 跟踪
    addServiceFollow(row) {
      const self = this;
      self.row = row;
      self.addFollowObj.content = null;
      self.addFollowObj._scheduleDF = false;
      self.addFollowDoing = false;
      self.addFollowDF = true;
    },
    setScheduleDF() {
      const self = this;
      if (!self.addFollowObj._scheduleDF) {
        return;
      }
      self.addFollowObj._title = null;
      self.addFollowObj._type = null;
      self.addFollowObj._shopId = null;
      self.addFollowObj._planAt = null;
      self.addFollowObj._planAt1 = null;
      self.addFollowObj._planAt2 = null;
      self.addFollowObj._content = null;
      self.getSources();
      self.addFollowObj._source = self.row.source;
      self.addFollowObj._sourceRemark = self.row.sourceRemark;
      self.addFollowObj._suggestId = self.row.suggestId;
      axios.all([ScheduleType.findByTenantId(), Shop.findByTenantId()]).then(
        axios.spread(function (scheduleTypes, shops) {
          if (scheduleTypes.status === 200) {
            self.scheduleTypes = scheduleTypes.data;
          } else {
            self.sysError();
          }
          if (shops.status === 200) {
            self.shops = shops.data;
            if (
              self.shops.find(
                (s) => s.id === self.Permit.currentUser()._shopId
              ) != null
            ) {
              self.addFollowObj.shopId = self.Permit.currentUser()._shopId;
            } else {
              self.addFollowObj.shopId = null;
            }
          } else {
            self.sysError();
          }
        })
      );
    },
    addServiceFollowSubmit() {
      const self = this;
      this.$refs.addFollowForm.validate((valid) => {
        if (valid) {
          self.addFollowDoing = true;
          Customer.createFollow(self.row.id, self.addFollowObj).then(function (
            res
          ) {
            self.addFollowDoing = false;
            self.addFollowDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.actionSuccess"),
                type: "success",
              });
              self.loadData();
              if (self.addFollowObj._scheduleDF == true) {
                const data = {
                  title: self.addFollowObj._title,
                  type: self.addFollowObj._type,
                  planAt:
                    Util.formatDate(self.addFollowObj._planAt1) +
                    " " +
                    self.addFollowObj._planAt2 +
                    ":00",
                  customerId: self.row.id,
                  customerName: self.row.name,
                  content: self.addFollowObj._content,
                  shopId: self.addFollowObj._shopId,
                };
                self.createSchedule(data);
              }
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    createSchedule(data) {
      const self = this;
      Schedule.create(data).then(function (res) {
        self.addDF = false;
        if (res.data.code === 200) {
        } else {
          self.sysError();
        }
      });
    },
    //-----
    dataProvider(params) {
      return Customer.search(params);
    },
  },
};
</script>
